import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-cra-funding",
    prompt: (guidanceItem) => `Please indicate when the ${guidanceItem.parameters.planShortName} will be funded and if post tax funding is permitted.`,
    openAction: {
        text: 'View Funding',
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/plans?planId=${guidanceItem.parameters.planId}`,
        row: "Contributions"
    },
    completeAction: {
    }
});


// WEBPACK FOOTER //
// ./src/guidance/items/guidance-cra-funding.js